<template>
    <v-dialog v-model="dialog" persistent max-width="600px">
        <template v-slot:activator="{ on, attrs }">
            <v-btn v-on="on" icon>
                <v-icon>mdi-pencil</v-icon>
            </v-btn>
        </template>
        <v-card>
            <v-card-title>
                <span class="headline">{{ titleComputed }}</span>
            </v-card-title>
            <v-card-subtitle class="text-left mt-2">
                <span>매뉴얼 구조 이름: {{ item.canonicalName }}</span>
            </v-card-subtitle>
            <v-card-text>
                <v-container>
                    <v-row class="mb-5">
                        <v-select
                                v-model="requestBody.type"
                                :items="['NODE', 'BOOK']"
                                label="타입"
                                hide-details
                                disabled
                                outlined></v-select>
                    </v-row>
                    <v-row class="mb-5">
                        <v-text-field
                                :disabled="requestBody.type !== 'BOOK'"
                                v-model="requestBody.mappingInformation"
                                label="매핑정보(TYPE BOOK ONLY)"
                                placeholder="이 필드는 자유롭습니다. 클라이언트에 맞춰서 필요한 정보를 입력해주세요."
                                hide-details outlined></v-text-field>
                    </v-row>
                    <v-row class="mb-5">
                        <v-text-field
                                v-model="requestBody.name"
                                label="매뉴얼 키(유니크키)"
                                placeholder="영문자(-대쉬 허용)만 가능하며 2~50자까지 설정할 수 있습니다."
                                hide-details outlined></v-text-field>
                    </v-row>
                    <v-row class="mb-5">
                        <v-text-field
                                v-model="requestBody.title"
                                label="매뉴얼 타이틀(번역키)"
                                placeholder="번역키로 사용할 매뉴얼 제목입니다."
                                hide-details outlined></v-text-field>
                    </v-row>
                    <v-row>
                        <v-textarea
                                v-model="requestBody.description"
                                label="매뉴얼설명"
                                rows="5" hide-details outlined></v-textarea>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="dialog = false">닫기</v-btn>
                <v-btn color="blue darken-1" text @click="apply" :disabled="!valid">수정</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import {PATH} from "@/constants";
    import {ON_MANUAL_RECEIVED} from "@/framework/listeners/listeners";

    export default {
        name: "ManualEditButton",
        props: {
            item: {
                type: Object,
                default: () => {},
            },
        },
        data() {
            return {
                dialog: false,
                requestBody: {
                    name: this.item.name,
                    title: this.item.manual.title,
                    mappingInformation: this.item.manual.mappingInformation,
                    description: this.item.manual.description,
                    type: this.item.manual.type,
                    id: this.item.id,
                },
                edited: false,
            }
        },
        computed: {
            valid() {
                return /^[A-Z][A-Z-]{0,48}[A-Z]$/.test(this.requestBody.name) && !!this.requestBody.title && this.requestBody.title.trim() && this.requestBody.type;
            },

            titleComputed() {
                return "매뉴얼 정보 수정";
            },
        },
        watch: {
            item() {
                this.requestBody.name = this.item.name;
                this.requestBody.title = this.item.manual.title;
                this.requestBody.mappingInformation = this.item.manual.mappingInformation;
                this.requestBody.description = this.item.manual.description;
                this.requestBody.type = this.item.manual.type;
                this.requestBody.id = this.item.id;
            },

            'requestBody.name'() {
                this.requestBody.name = this.requestBody.name.toUpperCase();
            },

            dialog() {
                if (!this.dialog && this.edited) {
                    this.notifyEvent(ON_MANUAL_RECEIVED);
                    this.edited = true;
                }
            },
        },
        methods: {
            apply() {
                this.requestSave();
            },

            requestSave() {
                this.$requestWithOverlay(PATH.MANUAL.UPDATE)
                    .setObject(this.requestBody)
                    .enqueue()
                    .then(res => {
                        this.edited = true;
                        this.dialog = false;
                    });
            }
        },
    }
</script>

<style scoped>

</style>